<template>
	<div class="person-panel-list" ref="$personPanelList">
		<app-loader v-if="isLoadingAll" :style="loaderStyle"/>
		<div class="person-panel-list__count">
			Найдено контактов:
			<div class="person-panel-list__count-number">{{ clients?.Count || 0 }}</div>
		</div>
		<div
			v-for="group in clients?.Groups"
			class="person-panel-list__group"
			:key="group.Id"
		>
			<div class="person-panel-list__group-name">
				{{ group.Name }}:
			</div>
			<template
				v-for="contact in group.Persons"
				:key="contact.Id"
			>
				<clients-panel-list-item
					:client="contact"
					:search-text="props.searchText"
				/>
				<div class="person-panel-list__divider"/>
			</template>
		</div>
		<div
			v-if="!isLoadingAll && isLoadingPartial"
			class="person-panel-list__partial"
		>
			<app-loader :style="partialLoaderStyle" />
		</div>
		<div
			v-else-if="!isLoadingAll && !canLoadNext"
			class="person-panel-list__end"
		>
			Все контакты загружены
		</div>
		<div
			v-if="isScrollBtnVisible"
			class="person-panel-list__scroll-top"
			@click="scrollListTop"
		>
			<app-icon
				class="client-item__footer-options-btn"
				name="arrow-up"
				width="24px"
				color="#fff"
				title="Наверх"

			/>
		</div>
	</div>
</template>

<script setup lang="ts">
import {
	computed,
	onBeforeUnmount,
	onMounted,
	ref, watch
} from "vue";
import ClientsPanelListItem from "@/components/main/clients-panel/ClientsPanelListItem.vue";
import AppLoader from "@/components/common/AppLoader.vue";
import AppIcon from "@/components/ui-kit/icon/AppIcon.vue";
import {projectPageStore} from "@/store/project-page";

const props = defineProps<{
	searchText: string;
}>()

const emit = defineEmits<{
	(e: 'on-get-partial'): void
}>()

const projectStore = projectPageStore()
const $personPanelList = ref<HTMLDivElement | null>(null)
const isScrollBtnVisible = ref(false)

const isLoadingAll = computed(() => projectStore.projectContactsLoading);
const isLoadingPartial = computed(() => projectStore.projectContactsPartialLoading);
const canLoadNext = computed(() => projectStore.canLoadNextProjectContacts);
const clients = computed(() => projectStore.projectContacts);

const scrollListTop = () => {
	$personPanelList.value?.scrollTo({
		top: 0
	});
}

const onScroll = () => {
	if (!$personPanelList.value) return

	isScrollBtnVisible.value = $personPanelList.value.scrollTop > 300
	if (
		!projectStore.projectContactsLoading
		&& !projectStore.projectContactsPartialLoading
		&& projectStore.canLoadNextProjectContacts
		&& $personPanelList.value.scrollTop + $personPanelList.value.offsetHeight > $personPanelList.value.scrollHeight - 1000
	) {
		emit('on-get-partial')
	}
}

onMounted(() => {
	$personPanelList.value?.addEventListener('scroll', onScroll)
})

onBeforeUnmount(() => {
	$personPanelList.value?.removeEventListener('scroll', onScroll)
})

watch(isLoadingAll, (newVal) => {
	if (newVal) {
		$personPanelList.value!.scrollTop = 0
	}
})

const loaderStyle = computed(() => ({
	'background-color': 'rgba(255, 255, 255, 0.5)'
}))

const partialLoaderStyle = computed(() => ({
	position: 'relative',
	height: '32px',
	'background-color': 'transparent'
}))

</script>

<style scoped lang="scss">
.person-panel-list {
	display: flex;
	flex-direction: column;
	flex: 1;
	position: relative;
	border-bottom-left-radius: 8px;
	border-bottom-right-radius: 8px;
	overflow: auto;
	background-color: #fff;

	&__count {
		display: flex;
		align-items: center;
		justify-content: center;
		margin-top: 4px;
		font-size: 12px;
		line-height: 18px;
		color: #4D4D4D;
		&-number {
			font-weight: 600;
			margin-left: 4px;
		}
	}

	&__divider {
		border-bottom: 1px solid #F2F2F2;
		margin-left: 8px;
	}

	&__end {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 100%;
		padding: 8px 0;
		font-size: 12px;
		line-height: 16px;
		color: #4D4D4D;
	}

	&__partial {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 100%;
		padding: 4px 0 8px;
	}

	&__group {
		display: flex;
		flex-direction: column;
	}

	&__group-name {
		font-size: 14px;
		line-height: 18px;
		font-weight: 500;
		color: #999999;
		padding: 4px 8px;
	}

	&__scroll-top {
		display: flex;
		align-items: center;
		justify-content: center;
		position: sticky;
		height: 30px;
		min-height: 30px;
		width: 30px;
		min-width: 30px;
		border-radius: 100%;
		bottom: 6px;
		left: calc(100% - 38px);
		background-color: #979797;
		cursor: pointer;
		transition: background-color 0.1s ease-in-out;

		&:hover {
			background-color: #858585;
		}
	}
}
</style>
